export const tooltipButtons = {
    next: {
      en: "Next",
      hi: "आगे बढ़ें",
      or: "ପରବର୍ତ୍ତୀ",
      mr: "पुढे जा"
    },
    stop: {
      en: "Stop the speaker",
      hi: "स्पीकर बंद करें",
      or: "ସ୍ପିକର୍ ବନ୍ଦ କରନ୍ତୁ",
      mr: "स्पीकर बंद करा"
    },
    finish: {
      en: "Get Started",
      hi: "ऐप चलना शुरू करें",
      or: "ଆରମ୍ଭ କରନ୍ତୁ",
      mr: "शुरू करा"
    },
    backToChat: {
      en: "Back to Chat",
      hi: "चैट पर वापस जाएं",
      or: "ଚାଟ୍‌କୁ ଫେରିଯାଆନ୍ତୁ",
      mr: "चॅटवर परत जा"
  },
  TooltipStart: {
    en: "Start",
    hi: "शुरू करें",
    or: "ଆରମ୍ଭ କରନ୍ତୁ",
    mr: "सुरुवात करा"
  }
  };

export const introHeading1 = {
  en: "Learn to use",
  hi: "हेल्थवाणी",
  or: "ହେଲ୍ଥଭାନି",
  mr: "हेल्थवाणी"
}
export const introHeading2 = {
  en: "HealthVaani",
  hi: "चलाना सीखें",
  or: "ବ୍ୟବହାର କରିବା ଶିଖନ୍ତୁ",
  mr: "वापरायला शिका"
}

export const introHeading2NeGD = {
  en: "Anganwadi Chatbot",
  hi: "",
  or: "",
  mr: ""
}
export const tooltipIntroContent = {
    en: "Learn to chat with me in minutes! Practice with me and don’t pause midway.",
    hi: "चैट करना मिनटों में सीखें! मेरे साथ-साथ चलाएं और बीच में रोकें नहीं।",
    or: "ମିନିଟ୍‌ ମଧ୍ୟରେ ମୋ ସହିତ ଚାଟ୍ କରିବା ଶିଖନ୍ତୁ! ମୋ ସହିତ ଅଭ୍ୟାସ କରନ୍ତୁ ଏବଂ ମଝିରେ ବିରତି ନିଅନ୍ତୁ ନାହିଁ।",
    mr: "काही मिनिटांमध्ये माझ्याशी चॅट करायला शिका ! माझ्यासोबत सराव करा आणि मध्येच थांबू नका"
}
export const introAudioContent = {
  en: "Learn to use Healthvaani. Learn to chat with me in minutes! Practice with me and don’t pause midway.",
  hi: "हेल्थवाणी चलाना सीखें. चैट करना मिनटों में सीखें! मेरे साथ-साथ चलाएं और बीच में रोकें नहीं।",
  or: "ହେଲ୍ଥଭାନି ବ୍ୟବହାର କରିବା ଶିଖନ୍ତୁ. ମିନିଟ୍‌ରେ ମୋ ସହିତ ଚାଟ୍ କରିବା ଶିଖନ୍ତୁ! ମୋ ସହିତ ଅଭ୍ୟାସ କରନ୍ତୁ ଏବଂ ମଝିରେ ବିରତି ନିଅନ୍ତୁ ନାହିଁ।",
  mr: "हेल्थवाणी वापरायला शिका. काही मिनिटांमध्ये माझ्याशी चॅट करायला शिका ! माझ्यासोबत सराव करा आणि मध्येच थांबू नका."
}
export const introAudioContentNeGD = {
  en: "Learn to use Anganwadi Chatbot. Learn to chat with me in minutes! Practice with me and don’t pause midway.",
  hi: "",
  or: "",
  mr: ""
}
export const speakerHeading1 = {
  en: "Don’t just read,",
  hi: "सिर्फ पढें नहीं,",
  or: "କେବଳ ପଢ଼ନ୍ତୁ ନାହିଁ,",
  mr: "फक्त वाचू नका,"
}
export const speakerHeading2 = {
  en: "listen too",
  hi: "सुनें भी।",
  or: "ଶୁଣନ୍ତୁ ମଧ୍ୟ",
  mr: "ऐकासुद्धा"
}
export const tooltipSpeakerContent = {
    en: "You can hear messages with 'speaker button' shown above",
    hi: "मैसेज सुनने के लिए ऊपर दिया 'स्पीकर' बटन दबाएं।",
    or: "ଉପରେ ଦେଖାଯାଇଥିବା 'ସ୍ପିକର ବଟନ୍' ସାହାଯ୍ୟରେ ଆପଣ ବାର୍ତ୍ତା ଶୁଣିପାରିବେ",
    mr: "वर दाखवलेले 'स्पीकर बटण' वापरून तुम्ही मॅसेज ऐकू शकता"
}
export const speakerAudioContent = {
  en: "Don’t just read, listen too. You can hear messages with 'speaker button' shown above",
  hi: "सिर्फ पढें नहीं, सुनें भी। मैसेज सुनने के लिए ऊपर दिया 'स्पीकर' बटन दबाएं।",
  or: "କେବଳ ପଢ଼ନ୍ତୁ ନାହିଁ, ଶୁଣନ୍ତୁ ମଧ୍ୟ। ଉପରେ ଦେଖାଯାଇଥିବା 'ସ୍ପିକର ବଟନ୍' ସାହାଯ୍ୟରେ ଆପଣ ବାର୍ତ୍ତା ଶୁଣିପାରିବେ।",
  mr: "फक्त वाचू नका, ऐकासुद्धा. वर दाखवलेले 'स्पीकर बटण' वापरून तुम्ही मॅसेज ऐकू शकता।"
}
export const inputHeading1 = {
  en: "Ask anything",
  hi: "जो चाहें,",
  or: "ଆପଣ ଯାହା,",
  mr: "तुम्हाला हवे"
}
export const inputHeading2 = {
  en: "you want.",
  hi: "वो पूछें।",
  or: "ଚାହିଁବେ ପଚାରନ୍ତୁ।",
  mr: "ते विचारा."
}
export const tooltipInputContent = {
  en: "Type any question you want. I understand even small typing mistakes.",
  hi: "मनचाहा सवाल टाइप करके पूछें, टाइपिंग की छोटी-मोटी गलतियाँ भी मैं समझ जाऊँगी!",
  or: "ତୁମେ ଯେକୌଣସି ପ୍ରଶ୍ନ ଟାଇପ୍ କର। ମୁଁ ଛୋଟ ଛୋଟ ଟାଇପିଂ ଭୁଲ ମଧ୍ୟ ବୁଝେ।",
  mr: "तुम्हाला हवा तो प्रश्न टाइप करा - मी अगदी लहान टायपिंग चुका पण समजू शकते."
}
export const inputAudioContent = {
  en: "Ask anything You Want. Type any question you want. I understand even small typing mistakes.",
  hi: "जो चाहें, वो पूछें। मनचाहा सवाल टाइप करके पूछें, टाइपिंग की छोटी-मोटी गलतियाँ भी मैं समझ जाऊँगी!",
  or: "ଆପଣ ଯାହା ଚାହିଁବେ ପଚାରନ୍ତୁ। ତୁମେ ଯେକୌଣସି ପ୍ରଶ୍ନ ଟାଇପ୍ କର। ମୁଁ ଛୋଟ ଛୋଟ ଟାଇପିଂ ଭୁଲ ମଧ୍ୟ ବୁଝେ।",
  mr: "तुम्हाला जे काही विचारायचे आहे ते विचारा. तुम्हाला हवा तो प्रश्न टाइप करा - मी अगदी लहान टायपिंग चुका पण समजू शकते."
}
export const sendHeaning1 = {
  en: "Send question",
  hi: "उत्तर पाने के लिए",
  or: "ଉତ୍ତର ପାଇବା ପାଇଁ",
  mr: "उत्तर मिळविण्यासाठी"
}
export const sendHeaning2 = {
  en: "to get an answer",
  hi: "सवाल भेजें",
  or: "ପ୍ରଶ୍ନ ପଠାନ୍ତୁ",
  mr: "प्रश्न पाठवा"
}
export const tooltipSendContent = {
  en: "Tap the ‘Send’ button shown below to submit your question.",
  hi: "उत्तर पाने के लिए सवाल नीचे दिखाए ‘सेंड बटन’ को दबाकर आगे भेजें।",
  or: "ଆପଣଙ୍କ ପ୍ରଶ୍ନ ଦାଖଲ କରିବା ପାଇଁ ତଳେ ଦେଖାଯାଉଥିବା ‘ପଠାନ୍ତୁ’ ବଟନ୍‌କୁ ଦବାନ୍ତୁ।",
  mr: "तुमचा प्रश्न सबमिट करण्यासाठी खाली दाखवलेल्या 'सेंड' बटणावर टॅप करा."
}
export const sendAudioContent = {
  en: "Send question to get an answer. Tap the ‘Send’ button shown below to submit your question.",
  hi: "उत्तर पाने के लिए सवाल भेजें. उत्तर पाने के लिए सवाल नीचे दिखाए ‘सेंड बटन’ को दबाकर आगे भेजें।",
  or: "ଉତ୍ତର ପାଇବା ପାଇଁ ପ୍ରଶ୍ନ ପଠାନ୍ତୁ. ଆପଣଙ୍କ ପ୍ରଶ୍ନ ଦାଖଲ କରିବା ପାଇଁ ତଳେ ଦେଖାଯାଉଥିବା ‘ପଠାନ୍ତୁ’ ବଟନ୍‌କୁ ଦବାନ୍ତୁ।",
  mr: "उत्तर मिळविण्यासाठी प्रश्न पाठवा. तुमचा प्रश्न सबमिट करण्यासाठी खाली दाखवलेल्या 'सेंड' बटणावर टॅप करा."
}
export const tooltipSendQuestion = {
  en: "What are the danger signs in a newborn baby?",
  hi: "नवजात शिशु में खतरे के लक्षण क्या हैं?",
  or: "ନବଜାତ ଶିଶୁରେ ଭାଗ୍ୟକାରୀ ଚିହ୍ନଗୁଡ଼ିକ କ’ଣ ହେଉଛି?",
  mr: "नवजात बाळामध्ये धोक्याची लक्षणे कोणती आहेत?"
}
export const MicIntroHeading1 = {
  en: "Speak and ask",
  hi: "बोलकर पूछना",
  or: "କଥା କହି",
  mr: "बोला आणि"
}
export const MicIntroHeading2 = {
  en: "questions",
  hi: "हुआ आसान।",
  or: "ପ୍ରଶ୍ନ ପଚାରନ୍ତୁ",
  mr: "प्रश्न विचारा"
}
export const MicIntroContent = {
  en: "Don’t just type your question - speak it, and I’ll record it in writing.",
  hi: "सवाल लिख कर ही नहीं, बोल कर भी पूछें - आप जो बोलेंगी, मैं उसे लिखित में दर्ज कर लूँगी ।",
  or: "କେବଳ ପ୍ରଶ୍ନ ଟାଇପ୍ କରନ୍ତୁ ନାହିଁ—କଥା କହି ପ୍ରଶ୍ନ ପଚାରନ୍ତୁ, ମୁଁ ଏହାକୁ ଲିଖିତ ରୂପରେ ରେକର୍ଡ କରିଦେବି।",
  mr: "तुमचा प्रश्न फक्त टाइप करू नका - तो बोला, आणि मी तो लेखी स्वरूपात रेकॉर्ड करेन."
}
export const MicIntroAudioContent = {
  en: "Speak and Ask Questions. Don’t just type your question speak it, and I’ll record it in writing.",
  hi: "बोलकर पूछना हुआ आसान। सवाल लिख कर ही नहीं, बोल कर भी पूछें - आप जो बोलेंगी, मैं उसे लिखित में दर्ज कर लूँगी ",
  or: "କଥା କହି ପ୍ରଶ୍ନ ପଚାରନ୍ତୁ, କେବଳ ପ୍ରଶ୍ନ ଟାଇପ୍ କରନ୍ତୁ ନାହିଁ—କଥା କହି ପ୍ରଶ୍ନ ପଚାରନ୍ତୁ, ମୁଁ ଏହାକୁ ଲିଖିତ ରୂପରେ ରେକର୍ଡ କରିଦେବି।",
  mr: "बोला आणि प्रश्न विचारा तुमचा प्रश्न फक्त टाइप करू नका - तो बोला, आणि मी तो लेखी स्वरूपात रेकॉर्ड करेन."
}
export const GridHeading1 = {
  en: "Select a Topic If",
  hi: "विषय चुनें,",
  or: "ଆପଣ ଚାହିଁଲେ",
  mr: "तुम्हाला हवा असलेला"
}
export const GridHeading2 = {
  en: "You Like",
  hi: "बात करें",
  or: "ଏକ ବିଷୟ ବାଛନ୍ତୁ",
  mr: "विषय निवडा"
}
export const GridContent = {
  en: "Start with example topics if you like. Tap the ‘Topic button’ below and select a topic.",
  hi: "आप चाहें तो नीचे उदाहरण के रूप में दिए गए विषय चुन सकते हैं। 'विषय बटन' दबाएं और अपना विषय चुनें",
  or: "ଆପଣ ଚାହିଁଲେ ଉଦାହରଣ ବିଷୟଗୁଡ଼ିକରୁ ଆରମ୍ଭ କରନ୍ତୁ। ତଳେ ଥିବା ‘ବିଷୟ’ ବଟନ୍ ଉପରେ ଟ୍ୟାପ୍ କରି ଏକ ବିଷୟ ବାଛନ୍ତୁ।",
  mr: "तुम्हाला वाटल्यास उदाहरणात्मक विषयांसह सुरुवात करा. खालील 'विषय बटणा' वर टॅप करा आणि विषय निवडा."
}
export const GridAudioContent = {
  en: "Select a Topic If You Like. Start with example topics if you like. Tap the Topic button below and select a topic.",
  hi: "विषय चुनें, बात करें. आप चाहें तो नीचे उदाहरण के रूप में दिए गए विषय चुन सकते हैं। 'विषय बटन' दबाएं और अपना विषय चुनें",
  or: "ଆପଣ ଚାହିଁଲେ ଏକ ବିଷୟ ବାଛନ୍ତୁ. ଆପଣ ଚାହିଁଲେ ଉଦାହରଣ ବିଷୟଗୁଡ଼ିକରୁ ଆରମ୍ଭ କରନ୍ତୁ। ତଳେ ଥିବା ‘ବିଷୟ’ ବଟନ୍ ଉପରେ ଟ୍ୟାପ୍ କରି ଏକ ବିଷୟ ବାଛନ୍ତୁ।",
  mr: "तुम्हाला हवा असलेला विषय निवडा तुम्हाला वाटल्यास उदाहरणात्मक विषयांनी सुरुवात करा. खालील 'विषय बटणा'वर टॅप करा आणि विषय निवडा."
}
export const chipsHeading1 = {
  en: "Select a Topic If",
  hi: "विषय चुनें,",
  or: "ନିଜ ପସନ୍ଦର ",
  mr: "तुम्हाला हवा असलेला"
}
export const chipsHeading2 = {
  en: " You Like",
  hi: "बात करें",
  or: "ଏକ ବିଷୟ ବାଛନ୍ତୁ",
  mr: "विषय निवडा"
}
export const chipsContent = {
  en: "Pick a topic and see related questions. You can ask about any topic related to work.",
  hi: "विषय चुनें और संबंधित सवाल देखें। काम से जुड़ा कोई भी सवाल पूछें।",
  or: "ଏକ ବିଷୟ ବାଛନ୍ତୁ ଏବଂ ସମ୍ପର୍କିତ ପ୍ରଶ୍ନଗୁଡ଼ିକ ଦେଖନ୍ତୁ। କାର୍ଯ୍ୟ ସମ୍ବନ୍ଧୀୟ ଯେକୌଣସି ବିଷୟରେ ଆପଣ ପ୍ରଶ୍ନ ପଚାରିପାରିବେ।",
  mr: "एक विषय निवडा आणि संबंधित प्रश्नांची उदाहरणे पहा. तुम्ही कधीही असेच प्रश्न विचारु शकता."
}
export const chipsAudioContent = {
  en: "Select a Topic If You Like. Pick a topic and see related questions. You can ask about any topic related to work.",
  hi: "विषय चुनें, बात करें. विषय चुनें और संबंधित सवाल देखें। काम से जुड़ा कोई भी सवाल पूछें।",
  or: "ଯଦି ଆପଣ ଚାହିଁବେ ତେବେ ଏକ ବିଷୟ ବାଛନ୍ତୁ. ଏକ ବିଷୟ ବାଛନ୍ତୁ ଏବଂ ସମ୍ପର୍କିତ ପ୍ରଶ୍ନଗୁଡ଼ିକ ଦେଖନ୍ତୁ। କାର୍ଯ୍ୟ ସମ୍ବନ୍ଧୀୟ ଯେକୌଣସି ବିଷୟରେ ଆପଣ ପ୍ରଶ୍ନ ପଚାରିପାରିବେ।",
  mr: "तुम्हाला हवा असलेला विषय निवडा एक विषय निवडा आणि संबंधित प्रश्नांची उदाहरणे पहा. तुम्ही कधीही असेच प्रश्न विचारु शकता."
}
export const tooltipQuestionChipsHeading1 = {
  en: "Try Example",
  hi: "उदाहरण सवाल",
  or: "ନିଜ ପସନ୍ଦର ",
  mr: "तुम्हाला हवा असलेला"
}
export const tooltipQuestionChipsHeading2 = {
  en: "Questions",
  hi: "देखें",
  or: "ଏକ ବିଷୟ ବାଛନ୍ତୁ",
  mr: "विषय निवडा"
}
export const tooltipQuestionChipsContent = {
  en: "Pick a question to get an answer, or ask me anything about your work.",
  hi: "यहाँ सवाल देखें, एक चुनें और उत्तर पाएं या अपने काम से जुड़ा कोई भी सवाल पूछें!",
  or: "ଏକ ବିଷୟ ବାଛନ୍ତୁ ଏବଂ ସମ୍ବନ୍ଧିତ ଉଦାହରଣ ପ୍ରଶ୍ନଗୁଡ଼ିକ ଦେଖନ୍ତୁ। ଆପଣ ଯେକୌଣସି ସମୟରେ ସେହିଭଳି ପ୍ରଶ୍ନ ପଚାରିପାରିବେ।",
  mr: "कोणताही प्रश्न निवडा आणि उत्तर मिळवा. तुमच्या कामाबद्दल मला असेच कोणतेही प्रश्न विचारा."
}
export const tooltipQuestionChipsAudioContent = {
  en: "Try Example Questions. Pick a question to get an answer, or ask me anything about your work.",
  hi: "उदाहरण सवाल देखें. यहाँ सवाल देखें, एक चुनें और उत्तर पाएं या अपने काम से जुड़ा कोई भी सवाल पूछें!",
  or: "ଯଦି ଆପଣ ଚାହିଁବେ ତେବେ ଏକ ବିଷୟ ବାଛନ୍ତୁ. ଏକ ବିଷୟ ବାଛନ୍ତୁ ଏବଂ ସମ୍ବନ୍ଧିତ ଉଦାହରଣ ପ୍ରଶ୍ନଗୁଡ଼ିକ ଦେଖନ୍ତୁ। ଆପଣ ଯେକୌଣସି ସମୟରେ ସେହିଭଳି ପ୍ରଶ୍ନ ପଚାରିପାରିବେ।",
  mr: "तुम्हाला हवा असलेला विषय निवडा. कोणताही प्रश्न निवडा आणि उत्तर मिळवा. तुमच्या कामाबद्दल मला असेच कोणतेही प्रश्न विचारा."
}
export const tooltipLoaderHeading1 = {
  en: "",
  hi: "लोड हो",
  or: "",
  mr: "लोड होत"
}
export const tooltipLoaderHeading2 = {
  en: "Loading...",
  hi: "रहा है...",
  or: "ଲୋଡ୍ ହେଉଛି...",
  mr: "आहे..."
}
export const tooltipLoaderContent = {
  en: "If the internet is slow, loading may take time",
  hi: "इंटरनेट धीमे होने पर लोड होने में समय लग सकता है।",
  or: "ଇଣ୍ଟରନେଟ୍ ଧୀର ହେଲେ ଲୋଡ୍ ହେବାକୁ ସମୟ ଲାଗିପାରେ।",
  mr: "इंटरनेट संथ असल्यास लोड होण्यासाठी काही वेळ लागू शकतो ।"
}
export const tooltipSourceHeading1 = {
  en: "Answers You",
  hi: "स्रोत आधारित,",
  or: "ବିଶ୍ୱାସଯୋଗ୍ୟ",
  mr: "तुम्हाला विश्वास ठेवता"
}
export const tooltipSourceHeading2 = {
  en: "Can Trust",
  hi: "सही उत्तर",
  or: "ଉତ୍ତର",
  mr: "येईल अशी उत्तरे"
}
export const tooltipSourceContent = {
  en: "All answers are from your modules and official documents. Tap the button above for sources.",
  hi: "सभी उत्तर आपके मॉड्यूल और सरकारी दस्तावेज़ों से लिए गए हैं। ऊपर दिखाया गया बटन दबाएँ और स्त्रोत देखें।",
  or: "ସମସ୍ତ ଉତ୍ତର ଆପଣଙ୍କ ମଡ୍ୟୁଲ୍ ଏବଂ ଅଧିକାରିକ ଦଳିଲରୁ ନିଆଯାଇଛି। ଉପରେ ଥିବା ବଟନ୍‌କୁ ଟାପ୍ କରନ୍ତୁ।",
  mr: "सर्व उत्तरे तुमच्या मॉड्यूल्स आणि अधिकृत कागदपत्रांमधून घेतली आहेत. स्त्रोतांसाठी वरील बटणावर टॅप करा."
}
export const tooltipSourceAudioContent = {
  en: "Answers You Can Trust. All answers are from your modules and official documents. Tap the button above for sources.",
  hi: "स्रोत आधारित, सही उत्तर. सभी उत्तर आपके मॉड्यूल और सरकारी दस्तावेज़ों से लिए गए हैं। ऊपर दिखाया गया बटन दबाएँ और स्त्रोत देखें।",
  or: "ବିଶ୍ୱାସଯୋଗ୍ୟ ଉତ୍ତର. ସମସ୍ତ ଉତ୍ତର ଆପଣଙ୍କ ମଡ୍ୟୁଲ୍ ଏବଂ ଅଧିକାରିକ ଦଳିଲରୁ ନିଆଯାଇଛି। ଉପରେ ଥିବା ବଟନ୍‌କୁ ଟାପ୍ କରନ୍ତୁ।",
  mr: "तुम्हाला विश्वास ठेवता येईल अशी उत्तरे सर्व उत्तरे तुमच्या मॉड्यूल्स आणि अधिकृत कागदपत्रांमधून घेतली आहेत. स्त्रोतांसाठी वरील बटणावर टॅप करा."
}
export const tooltipEndHeading1 = {
  en: "Now You are",
  hi: "अब आप हैं",
  or: "ଏବେ ଆପଣ",
  mr: "आता तुम्ही"
}
export const tooltipEndHeading2 = {
  en: "Ready!",
  hi: "रेडी !",
  or: "ପ୍ରସ୍ତୁତ!",
  mr: "तयार आहात!"
}
export const tooltipEndContent = {
  en: "Now you can use HealthVaani. If you need to learn again, tap the ‘Learn’ button above.",
  hi: "अब आप हेल्थवाणी चला सकती हैं। कुछ भी दोबारा सीखना हो तो ऊपर दिखाए ‘सीखें बटन’ दबाएं।",
  or: "ଏବେ ଆପଣ ହେଲ୍ଥଭାଣୀ ବ୍ୟବହାର କରିପାରିବେ। ଯଦି ଆପଣଙ୍କୁ ପୁଣି ଶିଖିବାକୁ ପଡିବ, ତେବେ ଉପରେ ଥିବା 'ଶିଖନ୍ତୁ' ବଟନ୍ ଉପରେ ଟ୍ୟାପ୍ କରନ୍ତୁ।",
  mr: "आता तुम्ही हेल्थवाणी वापरू शकता. जर तुम्हाला पुन्हा शिकायचे असेल, तर वरील 'शिका' बटणावर टॅप करा."
}
export const tooltipEndContentNeGD = {
  en: "Now you can use Anganwadi Chatbot. If you need to learn again, tap the ‘Learn’ button above.",
  hi: "",
  or: "",
  mr: ""
}
export const tooltipEndAudioContent = {
  en: "Now You are Ready. Now you can use HealthVaani. If you need to learn again, tap the ‘Learn’ button above.",
  hi: "अब आप हैं रेडी. अब आप हेल्थवाणी चला सकती हैं। कुछ भी दोबारा सीखना हो तो ऊपर दिखाए ‘सीखें बटन’ दबाएं।",
  or: "ଏବେ ଆପଣ ପ୍ରସ୍ତୁତ! ଏବେ ଆପଣ ହେଲ୍ଥଭାଣୀ ବ୍ୟବହାର କରିପାରିବେ। ଯଦି ଆପଣଙ୍କୁ ପୁଣି ଶିଖିବାକୁ ପଡିବ, ତେବେ ଉପରେ ଥିବା 'ଶିଖନ୍ତୁ' ବଟନ୍ ଉପରେ ଟ୍ୟାପ୍ କରନ୍ତୁ।",
  mr: "आता तुम्ही तयार आहात! आता तुम्ही हेल्थवाणी वापरू शकता. जर तुम्हाला पुन्हा शिकायचे असेल, तर वरील 'शिका' बटणावर टॅप करा."
}
export const tooltipEndAudioContentNeGD = {
  en: "Now You are Ready. Now you can use Anganwadi Chatbot. If you need to learn again, tap the Learn button above.",
  hi: "",
  or: "",
  mr: ""
}
export const tooltipImage = {
  Intro: ["/Assets/Images/Tooltip/IntroTooltip/IntroTooltip.png"],
  TooltipSpeaker: ["/Assets/Images/Tooltip/NarrationTooltip/NarrationTooltip1.png", "/Assets/Images/Tooltip/NarrationTooltip/NarrationTooltip2.png", "/Assets/Images/Tooltip/NarrationTooltip/NarrationTooltip3.png", "/Assets/Images/Tooltip/NarrationTooltip/NarrationTooltip4.png"],
  TooltipTyping: ["/Assets/Images/Tooltip/TypingTooltip/TypingTooltip1.png", "/Assets/Images/Tooltip/TypingTooltip/TypingTooltip2.png", "/Assets/Images/Tooltip/TypingTooltip/TypingTooltip3.png", "/Assets/Images/Tooltip/TypingTooltip/TypingTooltip4.png", "/Assets/Images/Tooltip/TypingTooltip/TypingTooltip5.png", "/Assets/Images/Tooltip/TypingTooltip/TypingTooltip6.png", "/Assets/Images/Tooltip/TypingTooltip/TypingTooltip7.png"],
  TooltipSend: ["/Assets/Images/Tooltip/SendTooltip/SendTooltip1.png", "/Assets/Images/Tooltip/SendTooltip/SendTooltip2.png", "/Assets/Images/Tooltip/SendTooltip/SendTooltip3.png", "/Assets/Images/Tooltip/SendTooltip/SendTooltip4.png"],
  TooltipMicIntro: ["/Assets/Images/Tooltip/MicTooltip/MicTooltip.png"],
  TooltipGrid: ["/Assets/Images/Tooltip/GridTooltip/GridTooltip.png"],
  TooltipChips: ["/Assets/Images/Tooltip/ChipsTooltip/ChipsTooltip1.png", "/Assets/Images/Tooltip/ChipsTooltip/ChipsTooltip2.png", "/Assets/Images/Tooltip/ChipsTooltip/ChipsTooltip3.png", "/Assets/Images/Tooltip/ChipsTooltip/ChipsTooltip4.png"],
  TooltipLoader: ["/Assets/Images/Tooltip/TooltipLoader/Loadertooltip.png"],
  TooltipQuestionChips: ["/Assets/Images/Tooltip/QuestionChipsTooltip/QuestionChipsTooltip1.png", "/Assets/Images/Tooltip/QuestionChipsTooltip/QuestionChipsTooltip2.png", "/Assets/Images/Tooltip/QuestionChipsTooltip/QuestionChipsTooltip3.png"],
  TooltipLoader2: ["/Assets/Images/Tooltip/TooltipLoader/Loadertooltip.png"],
  TooltipSource: ["/Assets/Images/Tooltip/SourceTooltip/SourceTooltip1.png", "/Assets/Images/Tooltip/SourceTooltip/SourceTooltip2.png", "/Assets/Images/Tooltip/SourceTooltip/SourceTooltip3.png"],
  TooltipEnd: ["/Assets/Images/Tooltip/EndTooltip/EndTooltip.png"]
}

export const tooltipChecklistContent = {
  en: "Learn how to use HealthVaani",
  hi: "हेल्थवाणी को चलाना सीखें",
  or: "ହେଲ୍ଥଭାଣୀ କିପରି ବ୍ୟବହାର କରିବେ ଶିଖନ୍ତୁ",
  mr: "हेल्थवाणी कसे वापरायचे हे शिका"
}
export const tooltipChecklistContentNeGD = {
  en: "Learn how to use Anganwadi Chatbot",
  hi: "आंगनवाड़ी चैटबॉट को चलाना सीखें",
  or: "ଅଙ୍ଗନୱାଡି ଚାଟବଟ୍ କିପରି ବ୍ୟବହାର କରିବେ ଶିଖନ୍ତୁ",
  mr: "Learn how to use Anganwadi Chatbot"
}
